// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__FVtuv","right":"Footer_right__16XRd","buttons":"Footer_buttons__1G6hy"};